import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import Icon from "../Icon";
import SubscribeButton from "../../../components/Library/SubscribeButton";
import { updateUnAuthedSubscriptions, updateUserSubscriptions } from "../../../actions/user";
import { getLocalItem, setLocalItem } from "../../../utils/localdb";

import styles from "./Subscribe.css";

class Subscribe extends Component {

  constructor(props) {
    super(props);

    this.state = {
      subscribing: false,
      alreadySubscribedTo: [],
      email: "",
    };
  }

  componentDidMount() {
    if (!this.props.isLoggedIn) {
      const alreadySubscribedTo = getLocalItem("AxiosSubscriptions");
      this.setState({ alreadySubscribedTo: alreadySubscribedTo || [] });
    }
    else if (this.props.user) {
      this.setState({ alreadySubscribedTo: this.props.user.subscriptions.map((s) => s.id) });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isLoggedIn && !this.props.user && nextProps.user) {
      this.setState({ alreadySubscribedTo: nextProps.user.subscriptions.map((s) => s.id) });
    }
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubscribing = () => {
    this.setState({ subscribing: true });
  };

  onSubscribe = () => {
    if (this.props.isLoggedIn) {
      return this.props.updateUserSubscriptions(this.props.user.subscriptions, this.props.subscription)
        .then(this.onSubscribeSuccess);
    } else {
      return this.props.updateUnAuthedSubscriptions(this.state.email, [this.props.subscription.id], this.props.source)
        .then(() => {
          setLocalItem(
            "AxiosSubscriptions",
            [
              ...(getLocalItem("AxiosSubscriptions") || []),
              this.props.subscription.id,
            ],
            { expires: 30 }
          );
        })
        .then(this.onSubscribeSuccess);
    }
  };

  onSubscribeSuccess = () => {
    this.setState({
      subscribing: false,
      alreadySubscribedTo: [...this.state.alreadySubscribedTo, this.props.subscription.id],
    });
  }

  render() {
    const { subscription, light } = this.props;
    if (!subscription) return null;
    const isSubscribed = this.state.alreadySubscribedTo.includes(subscription.id);

    return (
      <div className={this.props.className}>
        {
          this.state.subscribing ?
            <div className={styles.subscribing}>
              <input
                name="email"
                aria-label="Enter Your Email Address"
                className={classNames(styles.input, light && styles.lightInput)}
                placeholder="Your Email Address"
                value={this.state.email}
                onChange={this.onChange}
              />
              <button className={styles.submit} alt="Subscribe" onClick={this.onSubscribe}>
                <Icon name="chevron/right" className={styles.submitIcon} />
              </button>
            </div> :
            isSubscribed ?
              <SubscribeButton
                className={classNames(styles.subscribed, light && styles.lightButton)}
                disabled>
                <Icon name="check/rounded" className={classNames(styles.check, light && styles.lightCheck)}/>
                Subscribed
              </SubscribeButton> :
              <SubscribeButton
                className={classNames(styles.subscribe, light && styles.lightButton)}
                onClickSubscribe={this.props.isLoggedIn ? this.onSubscribe : this.onSubscribing}
                disabled={this.state.subscribing && this.state.email === ""}>
                Subscribe
              </SubscribeButton>
        }

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    isLoggedIn: !!state.authDrawer.authToken, // TODO: implement this when user stuff is done
  };
};

Subscribe.propTypes = {
  subscription: PropTypes.object,
  isLoggedIn: PropTypes.bool.isRequired,
  light: PropTypes.bool,
};

export default connect(mapStateToProps, { updateUnAuthedSubscriptions, updateUserSubscriptions })(Subscribe);
